/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import LinkIconButton from '@atlaskit/button/icon/link';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useNavigateBack } from '../../controllers/navigate-back-context/index.tsx';

const tooltip = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Go back',
	description: 'Tooltip for the sidebar navigation back button',
});

const label = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Navigate back to the previous page',
	description: 'Label for the sidebar navigation back button',
});

export function BackButton(): React.JSX.Element {
	const { formatMessage } = useIntl();
	const { previousUrl } = useNavigateBack();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<Tooltip content={formatMessage(tooltip)} hideTooltipOnMouseDown>
			<LinkIconButton
				href={previousUrl || ''}
				appearance="subtle"
				spacing="compact"
				icon={ArrowLeftIcon}
				label={formatMessage(label)}
				onClick={() => {
					fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
				}}
			/>
		</Tooltip>
	);
}
